import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { servicesResultsData } from "../../../../data/services/servicesResults";
import "./ServicesResults.css";

gsap.registerPlugin(ScrollTrigger);

const ServicesResults = () => {
  const sectionRef = useRef(null);
  const headlineRef = useRef(null);
  const cardsRef = useRef(null);
  const statsRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate headline
      gsap.fromTo(
        headlineRef.current,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      // Animate result cards
      const cards = cardsRef.current.querySelectorAll(
        ".services-results__card",
      );
      gsap.fromTo(
        cards,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: cardsRef.current,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      // Animate stats
      const stats = statsRef.current.querySelectorAll(
        ".services-results__stat",
      );
      gsap.fromTo(
        stats,
        { opacity: 0, scale: 0.8 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: statsRef.current,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="services-results" ref={sectionRef}>
      <div className="services-results__container">
        {/* Header */}
        <div className="services-results__header" ref={headlineRef}>
          <div className="services-results__badge">
            {servicesResultsData.badge}
          </div>
          <h2 className="services-results__headline">
            {servicesResultsData.headline}
          </h2>
          <p className="services-results__description">
            {servicesResultsData.description}
          </p>
        </div>

        {/* Result Cards */}
        <div className="services-results__grid" ref={cardsRef}>
          {servicesResultsData.results.map((result, index) => (
            <div key={index} className="services-results__card">
              <div
                className="services-results__card-icon"
                style={{ color: result.color }}
              >
                {result.icon}
              </div>
              <div className="services-results__card-metric">
                {result.metric}
              </div>
              <div className="services-results__card-label">{result.label}</div>
              <div className="services-results__card-service">
                {result.service}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats */}
        <div className="services-results__stats" ref={statsRef}>
          {servicesResultsData.stats.map((stat, index) => (
            <div key={index} className="services-results__stat">
              <div className="services-results__stat-number">{stat.number}</div>
              <div className="services-results__stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesResults;
